import styled from 'styled-components'

export const ControlPanelWrapper = styled.div`
  padding: 20px;
  background-color: ${({ theme }) => theme.forecast.background2};
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  color: white;
  overflow-y: auto;
  max-height: calc(80vh - 40px);
  width: 100%;
  box-sizing: border-box;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.4);
  }
`

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: white;
`

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #dddddd;
  margin-top: 12px;
`

export const ControlsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const ControlItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;
`

export const ControlLabel = styled.span`
  margin-right: 12px;
  flex-shrink: 0;
`

export const SliderRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SliderLabel = styled.span`
  width: 160px;
  flex-shrink: 0;
  margin-right: 16px;
`

export const SliderValue = styled.span`
  font-weight: bold;
`

export const SliderContainer = styled.div`
  flex: 1;
  padding-right: 8px;
`
